import './styles.css';
import { createRoot } from 'react-dom/client';
import { installAppLinks } from '@pathabroad/core/browser';
import { App } from './app/App';
import { ExtensionProvider } from './app/extension';
import { LangProvider } from './app/i18n';
import { SessionProvider } from './app/session';

/* inside the PathsAbroad phone app, links to other sites open in the app's own browser (outside it: nothing changes) */
installAppLinks({ lang: () => document.documentElement.lang });

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <LangProvider>
      <SessionProvider>
        <ExtensionProvider>
          <App />
        </ExtensionProvider>
      </SessionProvider>
    </LangProvider>,
  );
}
